(function() {
    'use strict';
    
a3_cabin_reports.factory('AimsCrewMemosFactory', AimsCrewMemosFactory)

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name AimsCrewMemosFactory
    * @description 
    *   Add, Update, Delete and Get Aims Crew Memos.
    * @ngInject
    */
function AimsCrewMemosFactory(GenericService) {
    
        /**
        * Initialize the AircaftPositions
        * @memberof AircaftPositionsFactory
        */
		function AimsCrewMemos() {
			this.Date = null;
			this.Line = null;
			this.OrderNo = null;
			
            
            this.GetId = GetId;
		}
				
		var objType = 'AimsCrewMemos';
		var objCallback = AimsCrewMemos; 
		
		var service = 
		{  
			getAimsCrewMemosFromStorage : getAimsCrewMemosFromStorage,
			setAimsCrewMemosToStorage : setAimsCrewMemosToStorage,
			clearAimsCrewMemosFactoryFromStorage : clearAimsCrewMemosFactoryFromStorage, 
			getAimsCrewMemosByDate : getAimsCrewMemosByDate,
            upsertAimsCrewMemos: upsertAimsCrewMemos,
            cleanOldAimsCrewMemos: cleanOldAimsCrewMemos
		};

        /**
         * Overide default get Id
         * @memberof AimsCrewMemosFactory
         * @returns {string} Id 
         */
		function GetId() {
			return this.Date;
		}
				
    
    
        /**
         * Get Aims Crew Memos
         * @memberof AimsCrewMemosFactory
         * @returns {Array} Aims Crew Memos
         */
		function getAimsCrewMemosFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Save Aims Crew Memos to storage
         * @memberof AimsCrewMemosFactory
         * @param {Array} A list of Aims Crew Memos
         */
		function setAimsCrewMemosToStorage(aircaftPositions) {
			GenericService.saveAll(aircaftPositions,objType,objCallback);
		}

        /**
         * Remove the  Aims Crew Memos of  the local storage
         * @memberof AimsCrewMemosFactory
         */
		function clearAimsCrewMemosFactoryFromStorage() {
			GenericService.removeAll(objType,objCallback);
		}
    
        /**
         * Get AimsCrewMemosFactory of this flight by date
         * @memberof AimsCrewMemosFactory
         * @returns {Object} AimsCrewMemosFactory
         */
		function getAimsCrewMemosByDate(date) {
		     var crewMemos = getAimsCrewMemosFromStorage();
            
            var datesMemos = [];
            var arrayLength = crewMemos.length;
			for (var i = 0; i < arrayLength; i++) {
				if (crewMemos[i].GetId() == date) {
					datesMemos.push(crewMemos[i]);
					
				}
			}
			return datesMemos;
		}

        /**
        *  Upsert Aims Crew Memos
        * @memberof AimsCrewMemosFactory
        */
        function upsertAimsCrewMemos(aimsCrewMemos) {
            var newCrewMemos = aimsCrewMemos.map(x => x.Date);
            var aimsCrewMemosLS = this.getAimsCrewMemosFromStorage();
            aimsCrewMemosLS = aimsCrewMemosLS.filter(x => !newCrewMemos.includes(x.Date));
            var allAimsCrewMemos = aimsCrewMemosLS.concat(aimsCrewMemos);
            setAimsCrewMemosToStorage(allAimsCrewMemos);
        }

        /**
         * Clean Old Data
         * @memberof AimsCrewMemosFactory
         */
		function cleanOldAimsCrewMemos() {
            var now = moment();
			getAimsCrewMemosFromStorage(function(crewMemos){
				var memosToKeep = crewMemos.filter(function(item){
                    var memoDate = moment(item.Date);
					return now.diff(memoDate, 'days') < 5;
				});
				// keep only the memo with pending reports
				setAimsCrewMemosToStorage(memosToKeep);			
			})
		}
               
        // var dutyDate = moment(cabinReportLocalEdits[i].DutyDate);
        // if (cabinReportLocalEdits[i].Status !== 'stored' && now.diff(dutyDate, 'days') < 5) {


	return service;
	}

})();